import { UsageTrackingFactory } from '../factories/usage-tracking.factory';

export function usageTracking(action: string): MethodDecorator {
  return function (_target: Function, _key: string, descriptor: any) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      UsageTrackingFactory.createTrackingService(action).addUsageTracking(
        this,
        args,
        action
      );
      return originalMethod.apply(this, args);
    };
    return descriptor;
  };
}
